import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ForgotPasswordState {
    isPasswordReset: boolean;
    resetError: string;
    isLoading: boolean;
    isOTPSent: boolean;
    otpError: string;
    email: string;
}

const initialState: ForgotPasswordState = {
    isPasswordReset: false,
    resetError: "",
    isLoading: false,
    isOTPSent: false,
    otpError: "",
    email: "",
}

const forgotPasswordSlice = createSlice({
    name: "forgotPassword",
    initialState,
    reducers: {
        requestPasswordResetStart(state: ForgotPasswordState) {
            state.isPasswordReset = false;
            state.resetError = "";
            state.isLoading = true;
        },
        passwordResetSuccess(state: ForgotPasswordState) {
            state.isLoading = false;
            state.isPasswordReset = true;
        },
        passwordResetError(state: ForgotPasswordState, action: PayloadAction<string>) {
            state.isLoading = false;
            state.resetError = action.payload;
            state.isPasswordReset = false;
        },
        sendOtpStart(state: ForgotPasswordState, action: PayloadAction<string>) {
            state.isLoading = true;
            state.otpError = "";
            state.isOTPSent = false;
            state.email = action.payload;
        },
        sendOtpSuccess(state: ForgotPasswordState) {
            state.isLoading = false;
            state.isOTPSent = true;
        },
        sendOtpError(state: ForgotPasswordState, action: PayloadAction<string>) {
            state.isLoading = false;
            state.otpError = action.payload;
            state.isOTPSent = false;
        },
    },
});

export const {
    requestPasswordResetStart,
    passwordResetSuccess,
    passwordResetError,
    sendOtpStart,
    sendOtpSuccess,
    sendOtpError
} = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;